import { useMutation } from "@tanstack/react-query";
import { api } from "../../../singleton/axios";

interface UnsubscribeByTokenResponse {
  unsubscribed: true;
  category: string;
}

/**
 * The emailed unsubscribe link, confirmed. PUBLIC: the signed token in the URL
 * is the whole credential, so this works signed out. It is a POST made on a
 * button press on purpose — mail scanners and link previews fetch URLs, and a
 * GET must never unsubscribe anyone.
 */
export const useUnsubscribeByToken = () =>
  useMutation({
    mutationFn: async (token: string) => {
      const { data } = await api.post<UnsubscribeByTokenResponse>(
        "/notifications/unsubscribe",
        undefined,
        { params: { token } },
      );
      return data;
    },
    retry: false,
  });
